export const PRACTICE_TEST = [
    {
        id: 1,
        test_name: 'Assessment Test',
        topic_ids: [9],
        use_practice_test_id: true,
        practice_test_id: 2,
        requires_subscription: false
    },
    {
        id: 2,
        test_name: 'Practice Test 1',
        use_practice_test_id: true,
        practice_test_id: 5,
        requires_subscription: true
    },
    {
        id: 3,
        test_name: 'Practice Test 2',
        use_practice_test_id: true,
        practice_test_id: 6,
        requires_subscription: true
    },
    {
        id: 4,
        test_name: 'Practice Test 3',
        use_practice_test_id: true,
        practice_test_id: 7,
        requires_subscription: true
    },
    {
        id: 5,
        test_name: 'Practice Test 4',
        use_practice_test_id: true,
        practice_test_id: 8,
        requires_subscription: true
    },
    {
        id: 6,
        test_name: 'Practice Test 5',
        use_practice_test_id: true,
        practice_test_id: 9,
        requires_subscription: true
    },
    {
        id: 7,
        test_name: 'Practice Test 6',
        use_practice_test_id: true,
        practice_test_id: 10,
        requires_subscription: true
    },
    {
        id: 8,
        test_name: 'Practice Test 7',
        use_practice_test_id: true,
        practice_test_id: 1,
        requires_subscription: true
    },
    {
        id: 9,
        test_name: 'Mock Exam 1',
        use_practice_test_id: true,
        practice_test_id: 3,
        requires_subscription: true
    },
    {
        id: 10,
        test_name: 'Mock Exam 2',
        use_practice_test_id: true,
        practice_test_id: 4,
        requires_subscription: true
    },
    
    
];

export const APP_DOMAIN_LIST = [
    {
        id: 1,
        domain_name: 'IS Auditing Process',
        chapters: [1],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'lock',
        requires_subscription: false,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 2,
        domain_name: 'Governance and Management of IT',
        chapters: [2],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'database-lock',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 3,
        domain_name: 'IS Acquisition, Development and Implementation',
        chapters: [3],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'cloud-lock',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 4,
        domain_name: 'IS Operations and Business Resilience',
        chapters: [4],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'cloud-tags',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 5,
        domain_name: 'Protection of Information Assets',
        chapters: [5],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'tools',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 10,
        num_articles: 3,
    },
    
];

export const QUESTION_VERSION_OF_JSON = 1
